import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  fontSize,
  pxToRem,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const slider = (theme: Theme) => css`
  min-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  background: ${theme.palette.primary.mainContrast};
`

export const carouselDescription = css`
  font-size: ${pxToRem(24)};
`

export const carouselList = css`
  display: flex;
  flex-direction: column;
  gap: ${size[16]};
  padding: 0;
  margin: ${size[20]} 0 ${size[32]};

  li {
    display: flex;
    align-items: center;
    gap: ${size[12]};
    flex-shrink: 0;
    font-size: ${fontSize.smMd};

    svg {
      fill: none;
    }
  }
`

export const active = css`
  position: relative;
`

export const inner = css`
  margin: 0 auto;
  min-width: unset;
  width: ${width.container.large};
`

export const content = css`
  height: 100%;
`

export const hero = css`
  position: relative;
  overflow: visible;
  z-index: 1;
  border-radius: 0 ${size[80]} 0 0;
  padding: 0;
  height: 100%;

  ${breakpoint.up('md')} {
    max-height: 60rem;
  }

  ${breakpoint.up('smMd')} {
    height: calc(100vh - 92px);
    min-height: ${width.container.standard};
    margin: 0 0;
    border-radius: 20px 200px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  ${breakpoint.down(48)} {
    margin-bottom: ${size[120]};
  }
`

export const heroCell = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${size[60]} 0 0;

  color: ${theme.palette.background.main};
`

export const cellContent = css`
  display: inline-block;
  align-self: center;
  max-width: ${width.container.compact};
  width: 100%;
  padding: 0 ${size[20]};

  ${breakpoint.up('smMd')} {
    margin-left: auto;
    padding: ${size[20]};
  }

  ${breakpoint.up(88)} {
    padding: 0;
  }
`

export const figure = css`
  flex-grow: 1;
  align-self: stretch;
  overflow: visible;
  width: 100%;
  margin: 0;

  ${breakpoint.up('smMd')} {
    position: relative;
    margin-top: 0;
    display: flex;
    align-items: flex-end;
  }
`

const gradientMobile = css`
  background: linear-gradient(
    0deg,
    rgba(69, 13, 135, 0.8),
    rgba(69, 13, 135, 0.8)
  );
`

const gradientDesktop = (theme: Theme) => css`
  background: linear-gradient(
    90deg,
    ${theme.palette.primary.mainContrast},
    ${theme.palette.primary.mainContrast}CC 40%,
    ${theme.palette.primary.mainContrast}4D 80%,
    transparent 100%
  );
`

export const background = (hasGradient: boolean) => (theme: Theme) => css`
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  max-width: unset;
  z-index: -1;

  img {
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    object-position: center;
  }

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;

    ${hasGradient && gradientMobile}
    ${breakpoint.up('smMd')} {
      width: 30%;
      right: 70%;
      ${hasGradient && gradientDesktop(theme)}
    }
  }
`

export const cta = css`
  display: flex;
  flex-direction: column;
  row-gap: ${size[12]};

  margin: ${size[60]} 0 ${size[24]};

  a {
    width: 100%;
  }

  ${breakpoint.up('smMd')} {
    flex-direction: row;
    column-gap: ${size[24]};
  }
`
